export default {
  isLoading: false,
  isBtnLoading: false,
  user: {},
  accountInfo: {},
  jwtToken: null,
  merchantPermissions: [],
  isLoggedIn: false,
  cartStatusList: [
    { id: 1, value: 'Not Set' },
    { id: 2, value: 'Processing' },
    { id: 3, value: 'Processed' },
    { id: 4, value: 'Shipped' },
    { id: 5, value: 'Reversed' },
    { id: 6, value: 'Refunded' },
    { id: 7, value: 'Completed' },
    { id: 8, value: 'Waiting' }
  ],
  permissions: [],
  roles: [],
  altCoins: [],
  transactions: [],
  page: 1,
  dashboardRange: null,
  exchangeList: [],
  locales: [],
  transferWiseConfig: null,
  countries: [],
  merchants: [],
  notifications: [],
  converter: {
    source: 1,
    sourceAltCoinId: 1,
    target: 0,
    targetAltCoinId: 625
  },
  balanceSheetBuyEnabledOnlineData: [],
  balanceSheetBuyDisabledOnlineData: [],
  balanceSheetBuyEnabledOfflineData: [],
  balanceSheetBuyDisabledOfflineData: [],
  balanceSheetBuyBothOnlineData: [],
  balanceSheetBuyBothOfflineData: [],
  searchKeyword: '',
  externalPaymentProviders: [],
  payoutTypes: [],
  isExpanded: false
}
